import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

interface Input {
    updates: {
        startDate: string;
        endDate: string;
        workstreamId: string;
        deliverableId: string;
    }[];
}

interface Options {
    onSuccess: () => void;
}

export function useApplyTimelinesMutation(options: Options) {
    const { project, refetch: refetchProject } = useProject();
    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.updateDeliverableTimelines({
                params: {
                    projectId: project.id,
                },
                body: {
                    updates: input.updates,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to apply timeline");
            }
            await refetchProject();
        },
        onSuccess: options.onSuccess,
    });
}
